/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type NotificationResourceAction = 'UNKNOWN' | 'NONE' | 'ACTIVATION_SUCCESS' | 'ACTIVATION_FAILED' | 'DEACTIVATION_INITIATED' | 'DEACTIVATION_SUCCESS' | 'DEACTIVATION_FAILED' | 'REQUEST_ACCESS_SUCCESS' | 'REQUEST_ACCESS_FAILED' | 'REQUEST_ACCESS_GRANTED' | 'REQUEST_ACCESS_DENIED' | 'UPGRADE_INITIATED' | 'UPGRADE_SUCCESS' | 'UPGRADE_FAILED' | 'SUBSCRIPTION_ACTIVATION_SUCCESS' | 'SUBSCRIPTION_EXPIRING' | 'SUBSCRIPTION_EXPIRED' | 'MAINTENANCE_SCHEDULED' | 'MAINTENANCE_UPDATED' | 'MAINTENANCE_CANCELED' | 'MAINTENANCE_COMPLETED' | 'ORG_OVERAGE_ENFORMENT_CREATED';

export const NotificationResourceAction = {

    UNKNOWN: 'UNKNOWN' as NotificationResourceAction,

    NONE: 'NONE' as NotificationResourceAction,

    ACTIVATION_SUCCESS: 'ACTIVATION_SUCCESS' as NotificationResourceAction,

    ACTIVATION_FAILED: 'ACTIVATION_FAILED' as NotificationResourceAction,

    DEACTIVATION_INITIATED: 'DEACTIVATION_INITIATED' as NotificationResourceAction,

    DEACTIVATION_SUCCESS: 'DEACTIVATION_SUCCESS' as NotificationResourceAction,

    DEACTIVATION_FAILED: 'DEACTIVATION_FAILED' as NotificationResourceAction,

    REQUEST_ACCESS_SUCCESS: 'REQUEST_ACCESS_SUCCESS' as NotificationResourceAction,

    REQUEST_ACCESS_FAILED: 'REQUEST_ACCESS_FAILED' as NotificationResourceAction,

    REQUEST_ACCESS_GRANTED: 'REQUEST_ACCESS_GRANTED' as NotificationResourceAction,

    REQUEST_ACCESS_DENIED: 'REQUEST_ACCESS_DENIED' as NotificationResourceAction,

    UPGRADE_INITIATED: 'UPGRADE_INITIATED' as NotificationResourceAction,

    UPGRADE_SUCCESS: 'UPGRADE_SUCCESS' as NotificationResourceAction,

    UPGRADE_FAILED: 'UPGRADE_FAILED' as NotificationResourceAction,

    SUBSCRIPTION_ACTIVATION_SUCCESS: 'SUBSCRIPTION_ACTIVATION_SUCCESS' as NotificationResourceAction,

    SUBSCRIPTION_EXPIRING: 'SUBSCRIPTION_EXPIRING' as NotificationResourceAction,

    SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED' as NotificationResourceAction,

    MAINTENANCE_SCHEDULED: 'MAINTENANCE_SCHEDULED' as NotificationResourceAction,

    MAINTENANCE_UPDATED: 'MAINTENANCE_UPDATED' as NotificationResourceAction,

    MAINTENANCE_CANCELED: 'MAINTENANCE_CANCELED' as NotificationResourceAction,

    MAINTENANCE_COMPLETED: 'MAINTENANCE_COMPLETED' as NotificationResourceAction,

    ORG_OVERAGE_ENFORMENT_CREATED: 'ORG_OVERAGE_ENFORMENT_CREATED' as NotificationResourceAction
};

